// Similar to MaterialOrientation, but reserved only for generation of 3d meshes.
export enum ProfileOrientation {
  Grid = 'grid',
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
